/* @flow */

import { type Funcionamento } from './types';
import { ENUM_NOMES_DIAS_SEMANA } from './constants';

const removerSegundos = s => s.substr(0, 5);

const formatarFuncionamento = ({ diaSemanaId, horaInicio, horaFim }: Funcionamento) => [
    ENUM_NOMES_DIAS_SEMANA[diaSemanaId],
    removerSegundos(horaInicio),
    'a',
    removerSegundos(horaFim),
].join(' ');

export default formatarFuncionamento;
